import { call, put, takeEvery } from 'redux-saga/effects'
import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'
import { renderErrorNotification } from '../../helpers/apiHelpers'

export function* loadShopOrderStates(action) {
  try {
    yield put({ type: 'SET_LOADING' })

    api.setAuthApi({ 'Authorization': sessionHelpers.getApplicationCookie('authentication_token') })

    const request = { url: `/shop_order_states` }
    const response = yield call(api.utility.get, api.path(request.url))

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'SHOP_ORDER_STATES_LOAD_SUCCEEDED',
      payload: { data: response.body }
    })

    yield put({ type: 'UNSET_LOADING'})
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'LOADING_FAILED' })
    yield put({ type: 'SET_LOADING_ERROR' })
    yield put({ type: 'UNSET_LOADING' })

    yield put(renderErrorNotification(`Error fetching data: ${apiErrorHelpers.toString(errors)}`))

    apiErrorHelpers.consoleLog(errors)
  }
} // loadShopOrderStates()

export default function* shopOrderStateSaga() {
  yield takeEvery('SHOP_ORDER_STATES_LOAD_SAGA', loadShopOrderStates)
}
